import { NAVY, GOLD, WHITE, fmt, isOver, PRIORITY_COLORS, STATUS_COLORS, STATUSES, PRIORITIES } from '../lib/ui';
import { Pill, Input, Select, Empty } from '../lib/ui';

export function MatterCard({ matter: m, onClick }) {
  return (
    <div onClick={onClick} style={{
      background:WHITE, borderRadius:10, border:'1px solid #E5E0D8',
      borderTop:`3px solid ${PRIORITY_COLORS[m.priority]||GOLD}`,
      padding:'16px 18px', cursor:'pointer', transition:'box-shadow 0.15s'
    }}
      onMouseEnter={e => e.currentTarget.style.boxShadow='0 4px 20px rgba(27,42,74,0.12)'}
      onMouseLeave={e => e.currentTarget.style.boxShadow='none'}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:8 }}>
        <div style={{ fontFamily:'Georgia,serif', fontSize:15, fontWeight:700, color:NAVY, lineHeight:1.3, flex:1, paddingRight:8 }}>{m.name}</div>
        <Pill label={m.priority} color={PRIORITY_COLORS[m.priority]} size={11} />
      </div>
      <div style={{ fontSize:12, color:'#777', marginBottom:8 }}>{m.client}{m.type ? ` · ${m.type}` : ''}</div>
      <div style={{ display:'flex', gap:6, flexWrap:'wrap', marginBottom:10 }}>
        <Pill label={m.status} color={STATUS_COLORS[m.status]} size={11} />
        {isOver(m.deadline) && m.status!=='Completed' && m.status!=='Closed' && <Pill label="Overdue" color="#C0392B" size={11} />}
      </div>
      <div style={{ display:'flex', justifyContent:'space-between', fontSize:11, color:'#888' }}>
        <span>Deadline: {fmt(m.deadline)}</span>
        <span>{(m.tasks||[]).length} tasks</span>
      </div>
    </div>
  );
}

export default function MattersList({ matters, setActiveMatter, setView, filterPreset }) {
  const [search, setSearch] = window.React.useState('');
  const [fStatus, setFStatus] = window.React.useState('');
  const [fPriority, setFPriority] = window.React.useState('');

  window.React.useEffect(() => {
    if (!filterPreset) return;
    if (filterPreset.priority) setFPriority(filterPreset.priority);
    if (filterPreset.status)   setFStatus(filterPreset.status);
  }, [filterPreset]);

  const PRIORITY_ORDER = { Critical:0, High:1, Medium:2, Low:3 };

  const filtered = matters.filter(m => {
    const q = search.toLowerCase();
    return (!q || m.name.toLowerCase().includes(q) || m.client.toLowerCase().includes(q))
      && (!fStatus   || m.status   === fStatus)
      && (!fPriority || m.priority === fPriority);
  }).sort((a,b) => (PRIORITY_ORDER[a.priority]??99) - (PRIORITY_ORDER[b.priority]??99));

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
      <div style={{ display:'flex', gap:10, flexWrap:'wrap' }}>
        <Input placeholder="Search matters, clients…" value={search} onChange={e=>setSearch(e.target.value)} style={{ maxWidth:280 }} />
        <Select value={fStatus} onChange={e=>setFStatus(e.target.value)} style={{ maxWidth:190 }}>
          <option value="">All Statuses</option>
          {STATUSES.map(s=><option key={s}>{s}</option>)}
        </Select>
        <Select value={fPriority} onChange={e=>setFPriority(e.target.value)} style={{ maxWidth:160 }}>
          <option value="">All Priorities</option>
          {PRIORITIES.map(p=><option key={p}>{p}</option>)}
        </Select>
      </div>
      <div className="matters-grid" style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(300px,1fr))', gap:16 }}>
        {filtered.map(m => (
          <MatterCard key={m.id} matter={m} onClick={() => { setActiveMatter(m.id); setView('matters'); }} />
        ))}
        {filtered.length===0 && <Empty text="No matters found." />}
      </div>
    </div>
  );
}
